export default "__VITE_ASSET__C$dTSWp0__"